import Resources from "../../shared/actions/resourcesActions";

export default class MailJetResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "account", `/api/v1/support_utils/accounts_info`);
  }
}
